export function validateIp(ip) {
  if (!ip || typeof ip !== "string") {
    return false;
  }

  // Remove any whitespace
  ip = ip.trim();

  // IPv4 validation
  const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  // IPv6 validation (simplified - covers most common cases)
  const ipv6Regex =
    /^(?:(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(?:[0-9a-fA-F]{1,4}:){1,7}:|(?:[0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|(?:[0-9a-fA-F]{1,4}:){1,5}(?::[0-9a-fA-F]{1,4}){1,2}|(?:[0-9a-fA-F]{1,4}:){1,4}(?::[0-9a-fA-F]{1,4}){1,3}|(?:[0-9a-fA-F]{1,4}:){1,3}(?::[0-9a-fA-F]{1,4}){1,4}|(?:[0-9a-fA-F]{1,4}:){1,2}(?::[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:(?:(?::[0-9a-fA-F]{1,4}){1,6})|:(?:(?::[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(?::[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(?:ffff(?::0{1,4}){0,1}:){0,1}(?:(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9])|(?:[0-9a-fA-F]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;

  return ipv4Regex.test(ip) || ipv6Regex.test(ip);
}

export function parseIp(input) {
  if (!input || typeof input !== "string") {
    return null;
  }

  input = input.trim();

  // Check for IPv6 with port [::1]:8080
  const ipv6WithPortRegex = /^\[([^\]]+)\]:(\d+)$/;
  const ipv6Match = input.match(ipv6WithPortRegex);
  if (ipv6Match) {
    const ip = ipv6Match[1];
    const port = parseInt(ipv6Match[2], 10);
    if (validateIp(ip) && port > 0 && port <= 65535) {
      return ip;
    }
    return null;
  }

  // Check for IPv4 with port 192.168.1.1:8080
  const ipv4WithPortRegex = /^([^:]+):(\d+)$/;
  const ipv4Match = input.match(ipv4WithPortRegex);
  if (ipv4Match) {
    const ip = ipv4Match[1];
    const port = parseInt(ipv4Match[2], 10);
    if (validateIp(ip) && port > 0 && port <= 65535) {
      return ip;
    }
    return null;
  }

  // No port specified, just validate IP
  if (validateIp(input)) {
    return input;
  }

  return null;
}
